import styled from "@emotion/styled";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";

const Container = styled.div`
  padding: 32px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.neutral.main};
  color: ${({ theme }) => theme.palette.primary.main};
  box-shadow: 10px 10px 20px 0px rgba(138, 138, 138, 0.15);
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.main};
    color: #fff;

    .MuiSvgIcon-root {
      color: #fff;
    }
  }
`;

const Title = styled.div``;

const Stat = styled.div`
  font-weight: 900;
  font-size: 40px;
`;

const Currency = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

export const StatCard = ({ title, stat, isVisible, toggleVisibility }) => {
  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Title>{title}</Title>
      </Stack>
      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Stat>
          {isVisible ? (
            <>
              {Number(stat).toLocaleString()} <Currency>ETB</Currency>
            </>
          ) : (
            <>
              **** <Currency>ETB</Currency>
            </>
          )}
        </Stat>
        <IconButton onClick={toggleVisibility}>
          {isVisible ? (
            <VisibilityOutlined color="primary" />
          ) : (
            <VisibilityOffOutlined color="primary" />
          )}
        </IconButton>
      </Stack>
    </Container>
  );
};
